// Limpia HTML antes de mostrarlo con v-html. Usa la misma lista blanca que el backend
// aplica a respuesta_admin (docs/pqr-respuesta-contrato-api.md). Sirve también para el
// HTML que devuelve la IA, que el servidor no limpia.

const ALLOWED = {
    p: [], br: [], strong: [], b: [], em: [], i: [], u: [], s: [],
    ul: [], ol: [], li: [], h2: [], h3: [], blockquote: [], pre: [], code: [],
    a: ['href', 'target'],
    img: ['src', 'alt', 'width', 'height'],
};

// Se eliminan con todo su contenido; las demás etiquetas no permitidas solo se desenvuelven
const DROP = ['script', 'style', 'iframe', 'object', 'embed', 'noscript', 'template', 'svg', 'math', 'form', 'input', 'textarea', 'select', 'button', 'link', 'meta'];

const isSafeUrl = (value, protocols) => {
    try {
        return protocols.includes(new URL(value, window.location.href).protocol);
    } catch (e) {
        return false;
    }
};

const cleanNode = (node) => {
    Array.from(node.childNodes).forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) return;
        if (child.nodeType !== Node.ELEMENT_NODE) {
            child.remove();
            return;
        }

        const tag = child.tagName.toLowerCase();

        if (DROP.includes(tag)) {
            child.remove();
            return;
        }

        cleanNode(child);

        if (!ALLOWED[tag]) {
            child.replaceWith(...Array.from(child.childNodes));
            return;
        }

        Array.from(child.attributes).forEach((attr) => {
            if (!ALLOWED[tag].includes(attr.name)) child.removeAttribute(attr.name);
        });

        if (tag === 'a') {
            if (!isSafeUrl(child.getAttribute('href') || '', ['http:', 'https:', 'mailto:'])) {
                child.removeAttribute('href');
            }
            child.setAttribute('target', '_blank');
            child.setAttribute('rel', 'noopener noreferrer');
        }

        if (tag === 'img' && !isSafeUrl(child.getAttribute('src') || '', ['http:', 'https:'])) {
            child.remove();
        }
    });
};

export const sanitizeHtml = (html) => {
    if (!html) return '';
    const doc = new DOMParser().parseFromString(String(html), 'text/html');
    cleanNode(doc.body);
    return doc.body.innerHTML;
};

// Las respuestas viejas son texto plano: se muestran con white-space: pre-line
export const isHtml = (value) => /<\/?[a-z][\s\S]*>/i.test(value || '');

// Texto plano a párrafos HTML, escapado
export const textToHtml = (text) => {
    if (!text) return '';
    const div = document.createElement('div');
    return String(text)
        .split(/\r?\n/)
        .map((line) => {
            div.textContent = line;
            return `<p>${div.innerHTML || '<br>'}</p>`;
        })
        .join('');
};

export const htmlToText = (html) => {
    if (!html) return '';
    if (!isHtml(html)) return String(html);
    return new DOMParser().parseFromString(String(html), 'text/html').body.textContent || '';
};
